import client from 'api/client';
import { AxiosResponse, AxiosRequestConfig } from 'axios';

export function get(
    email: string,
    customConfig?: AxiosRequestConfig
): Promise<AxiosResponse<{ msg: string }>> {
    return client.get<{ msg: string }>(`/check_email/${email}`, customConfig);
}
